import { RootStoreState } from '@/store';
import { ActionContext, Module } from 'vuex';
import ApiServiceWrapper from '@/shared/api-request.service';
export interface SandboxAutoRenewalState {
  autoRenewalList: any[];
}

export default {
  state:{
    autoRenewalList:[],
  },
  mutations:{
    setAutoRenewalList(state, payload) {
      const rowAutoRenewalList : any = payload;
      rowAutoRenewalList.map((ele: any, index: number) => {
        ele._key =  index;
      });
      state.autoRenewalList = [...rowAutoRenewalList];
    },
  },
  actions:{
    getAutoRenewals(context: ActionContext<SandboxAutoRenewalState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'order/get-auto-renewals';
      return ApiServiceWrapper.get(endpoint);
    },
  },
  getters:{
    getAutoRenewalList : state => state.autoRenewalList,
  },
  namespaced: true,
} as Module<SandboxAutoRenewalState, RootStoreState>;
